import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

class CountUp {
  constructor(el) {
    this.dom = {el: el};
    this.units = this.dom.el.querySelectorAll('[data-js="countup-unit"]');
    // this.circles = this.dom.el.querySelectorAll('[data-js="animation-circle"]');

    gsap.registerPlugin(ScrollTrigger);

    this.init();
  }

  init() {
    [...this.units].forEach(el => {
      ScrollTrigger.create({
        trigger: el,
        start: 'top 80%',
        markers: false,
        once: true,
        onEnter: (self) => {
          const animationCircle = el.querySelector('[data-js="animation-circle"]');
          if (animationCircle) animationCircle.classList.add('is-animation');

          const countupNumber = el.querySelectorAll('[data-js="countup-number"]');
          
          [...countupNumber].forEach(cn => {
            const counterEle = cn.querySelector('[data-js="countup-value"]');
            const from = parseFloat(cn.dataset.from || 0);
            const to = parseFloat(cn.dataset.to || 0);
            const duration = parseInt(cn.dataset.duration) || 1500;
    
            if (!Number.isFinite(from) || !Number.isFinite(to) || from > to) {
              return false;
            }
    
            const increment = to - from;
            const deciamlPointLength = this.getDecimalPointLength(cn.dataset.to);
            const startTime = performance.now();
    
            const countUp = (timestamp) => {
              const elapsed = performance.now() - startTime;
              const countValue = from + ((elapsed / duration) * increment);
            
              if (countValue >= to) {
                // 最終値を小数点以下を含めて表示
                counterEle.innerText = parseFloat(to.toFixed(deciamlPointLength)).toLocaleString(undefined, {
                  minimumFractionDigits: deciamlPointLength,
                  maximumFractionDigits: deciamlPointLength,
                });
              } else {
                // 中間値を小数点以下を含めて表示
                counterEle.innerText = parseFloat(countValue.toFixed(deciamlPointLength)).toLocaleString(undefined, {
                  minimumFractionDigits: deciamlPointLength,
                  maximumFractionDigits: deciamlPointLength,
                });
                requestAnimationFrame(countUp);
              }
            };
            
            requestAnimationFrame(countUp);
          })
        },
      });
    });
  }

  isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
  }
  
  getDecimalPointLength(n) {
    return (String(n).split('.')[1] || '').length;
  }
}

export default CountUp